<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div class="row">
          <div class="col">
            <v-btn
              color="primary"
              :to="{
                name: 'Login',
                params: { namespaceonly: true },
              }"
            >
              {{ $t('button.accueil') }}
            </v-btn>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <strong> {{ $t('assistance.question') }} </strong>
            <p>{{ $t('assistance.centreOuvert') }}</p>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex>
        <div class="row">
          <div class="col-xl-3 col-md-3">
            <v-layout row>
              <strong> {{ $t('assistance.gestionRDV.libelle') }} </strong>
            </v-layout>
            <v-layout row>
              E-mail: <span style="padding-left: 5px"></span>
              <a href="mailto:bilan@leciem.org"> bilan@leciem.org</a>
            </v-layout>
          </div>
          <div class="col-xl-3 col-md-3">
            <strong> {{ $t('assistance.relationClient.libelle') }} </strong>
            <v-layout row>
              E-mail:<span style="padding-left: 5px"></span>
              <a href="mailto:relationclient@leciem.org"
                >relationclient@leciem.org</a
              >
            </v-layout>
          </div>
          <div class="col-xl-3 col-md-3">
            <v-layout row>
              <strong> {{ $t('assistance.suiviMedical.libelle') }} </strong>
            </v-layout>
            <v-layout row>
              <p>
                E-mail:
                <a href="mailto:suivimedical@leciem.org"
                  >suivimedical@leciem.org</a
                >
              </p>
            </v-layout>
          </div>
          <div class="col-xl-3 col-md-3">
            <v-layout row>
              <strong> {{ $t('assistance.qualite.libelle') }} </strong>
            </v-layout>
            <v-layout row>
              <p>
                E-mail:
                <a href="mailto:qualite@leciem.org">qualite@leciem.org</a>
              </p>
            </v-layout>
          </div>
        </div>
        <div
          class="row"
          v-if="this.roleCorrespondant && gestionnaire.name != null"
        >
          <div class="col-xl-9 col-md-6">
            <strong
              >{{ $t('assistance.gestionnaire') }} :
              {{ this.gestionnaire.name }}
            </strong>
          </div>
          <div class="col-xl-3 col-md-6">
            <div class="row">
              <div class="col-6">
                <v-btn
                  class="btn btn-danger"
                  name="action"
                  color="primary"
                  value="index"
                  >{{ $t('assistance.envoyerMail') }}
                </v-btn>
              </div>

              <div class="col-6">
                <v-btn
                  class="btn btn-danger"
                  name="action"
                  color="primary"
                  value="index"
                  >{{ this.gestionnaire.telephone }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <v-flex justify-end align-end style="height: 90vh; width: 100%">
          <v-img height="100%" width="100%">
            <l-map
              v-if="showMap"
              :zoom="zoom"
              :center="center"
              :options="mapOptions"
              style="height: 100%"
              @update:center="centerUpdate"
              @update:zoom="zoomUpdate"
            >
              <l-tile-layer :url="url" :attribution="attribution" />
              <l-marker ref="marker" :lat-lng="withPopup">
                <l-popup @ready="openPopup">
                  <v-flex>
                    <H2>
                      Centre interprofessionnel et<br />
                      Examens Médicaux CIEM
                    </H2>
                    <p>
                      15-17 rue Rémy Dumoncel
                      <br />75014 Paris <br />01 42 22 54 90 <br /><a
                        href="https://www.leciem.com"
                        target="_blank"
                        >leciem.com</a
                      >
                    </p>
                    <a
                      rel="noopener noreferrer"
                      href="https://maps.app.goo.gl/Uyr9PkzfVMeSkpyE6"
                      target="_blank"
                      >Itinéraire
                    </a>
                  </v-flex>
                </l-popup>
              </l-marker>
            </l-map>
          </v-img>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet'
import Api from '@/utils/api'

export default {
  name: 'ForgotAssistance',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    //LTooltip,
  },
  created() {
    if (this.roleCorrespondant) {
      new Api('getGestionnaire')
        .get()
        .then((response) => {
          this.gestionnaire = response.body
        })
        .catch(() => {
          // TODO gestion du cas d'erreur not found
        })
    }
  },
  computed: {
    roleCorrespondant() {
      return this.$auth.hasRole('ROLE_CORRESPONDANT')
    },
  },
  mounted() {},
  data() {
    return {
      zoom: 19,
      center: latLng(48.8297371,2.3319604),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(48.8297371, 2.3319604),
      currentZoom: 11.5,
      currentCenter: latLng(48.8297371, 2.3319604),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,

      gestionnaire: {
        name: null,
        telephone: null,
        email: null,
        standard: null,
      },
    }
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
    },
    showLongText() {
      this.showParagraph = !this.showParagraph
    },
    openPopup() {
      this.$refs.marker.mapObject.openPopup()
    },
  },
}
</script>
